import * as React from 'react';

import { globalDialogInit } from 'global-dialog-init';
import { Root, createRoot } from 'react-dom/client';

import { Configuration, setConfiguration } from '@p2l/config';
import { TranslationsProvider } from '@p2l/react-utils';

import { REQUIRED_SERVICES } from 'consts';

import { App } from './components';
import translations from './translations.json';

globalDialogInit();

let root: Root;

const initApp = (config: Configuration) => {
  root.render(
    <TranslationsProvider culture={config.culture} translations={[translations]}>
      <App />
    </TranslationsProvider>
  );
};

export const bootstrap = (config: Configuration, serviceCollection: any) => {
  if (setConfiguration(serviceCollection, config, REQUIRED_SERVICES)) {
    let inactivityDialogId = 'inactivity-dialog-root';
    let mountElement = document.createElement('div');

    mountElement.setAttribute('id', inactivityDialogId);
    document.body.appendChild(mountElement);

    root = createRoot(document.getElementById(inactivityDialogId)!);

    initApp(config);
  }
};

export const destroy = () => {
  if (root) {
    root.unmount();
  }
};
